import { inject, Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { calander } from '../mocks/calander.mock';
/**
 * NgbDatePickerTranslateService
 */
@Injectable()
/**
 * NgbDatePickerTranslateService
 * @class NgbDatePickerTranslateService
 * @extends NgbDatepickerI18n
 */
export class NgbDatePickerTranslateService extends NgbDatepickerI18n {
  /**
   * inject dependecy
   * @param {TranslateService} translateService
   */
  private translateService = inject(TranslateService);

  /**
   * retrun the label of the day
   * @param {number} weekday 
   * @returns {string}
   */
  getWeekdayLabel(weekday: number): string { return this.getCalendar().weekdays[weekday - 1]; }
  /**
   * return the short name of the month
   * @param {number} month 
   * @returns {string}
   */
  getMonthShortName(month: number): string { return this.getCalendar().months[month - 1]; }
  /**
   * return the short name of the day
   * @param weekday 
   * @returns {string} 
   */
  getWeekdayShortName(weekday: number): string { return this.getCalendar().weekdays[weekday - 1]; }
  /**
   * return the calendar for the current language, falling back to english
   * when the language has no calendar defined
   * @returns {{ weekdays: string[]; months: string[] }}
   */
  private getCalendar(): { weekdays: string[]; months: string[] } {
    return calander[this.translateService.currentLang] ?? calander.en;
  }
  /**
   * return the full name of the month
   * @param {number} month 
   * @returns {string}
   */
  getMonthFullName(month: number): string { return this.getMonthShortName(month); }
  /**
   * get the aria label of the day
   * @param {NgbDateStruct} date 
   * @returns {string}
   */
  getDayAriaLabel(date: NgbDateStruct): string { return `${date.day}-${date.month}-${date.year}`; }
}
